export default __webpack_public_path__ + "static/media/app1.9c140bc5.PNG";